import { render } from "./TokenDetailAddressForm.vue?vue&type=template&id=b01d3d3e&scoped=true"
import script from "./TokenDetailAddressForm.vue?vue&type=script&lang=js"
export * from "./TokenDetailAddressForm.vue?vue&type=script&lang=js"

import "./TokenDetailAddressForm.vue?vue&type=style&index=0&id=b01d3d3e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b01d3d3e"]])

export default __exports__